// extracted by mini-css-extract-plugin
export var heroImageWidth = "infakt-module--heroImageWidth--sY1Ue";
export var heroCopyWidth = "infakt-module--heroCopyWidth--Ma6xZ";
export var infaktLogoWrapper = "infakt-module--infaktLogoWrapper--f34Ae";
export var main = "infakt-module--main--N1O44";
export var logo = "infakt-module--logo--8qPCZ";